/**
 * @format
 */
import { api } from '@/scripts/api';

export const DocumentInsertTagsService = {
    getAll(documentId) {
        return new Promise((resolve, reject) => {
            const service = `/service/DocumentTags/?$filter=DocumentId eq ${documentId}&$expand=QuoteTotalTags`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    get(tagId, documentId) {
        return new Promise((resolve, reject) => {
            const service = `/service/DocumentTags/?$filter=DocumentId eq ${documentId} and Id eq ${tagId}`;

            api.get(service).then(resolve).catch(reject);
        });
    },
};
